import { fetcher } from '@commenda/utils';

export const retireBillingPrice = async (priceId: string) => {
  const response = await fetcher(`commenda-billing/catalog/prices/${priceId}/retire`, {
    method: 'POST',
  });

  return response;
};
